// moms-harness:anchor v2
// Spec: docs/spec/auth/LOGISPRD-10053-okta-app-access-denied.yaml

import React, { useEffect } from 'react'
import { useCheckUser } from '@/services/auth/useAuthQueries'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuthStorage } from '@/utils/storage/AuthStorage'
import { PATHS } from '@/utils/routes/paths'
import useLoginSuccessFlow from '@/pages/auth/useLoginSuccessFlow'
import { AuthUtils } from '@/utils/AuthUtils'
import { Utils } from '@/utils/Utils'
import { AUTH_MEMBERSHIP_ERROR_CODES } from '@/utils/consts'

function AuthChecker() {
  const location = useLocation()
  const navigate = useNavigate()
  const checkUser = useCheckUser()
  const { onCheckAuthFlow } = useLoginSuccessFlow()

  useEffect(function onCheckToken() {
    // LOGISPRD-7099: Okta 콜백/로그인/성공 랜딩 경로는 AuthChecker 가 redirect 로 가로채지 않음(콜백은 ?code= 보존)
    if (['/login/callback', '/login', '/login/success'].includes(location.pathname)) return

    /**** 비로그인 *****/
    const authToken = AuthStorage.auth.get()
    // LOGISPRD-7099: Okta 세션(Knox 토큰 없음)도 로그인으로 인정 — 안 그러면 메인 진입 시 /auth/login 으로 redirect 루프
    const isAuthed = !!authToken || AuthStorage.authMode.get() === 'okta'
    const isOnAuth = location.pathname.startsWith(PATHS.auth)

    // 비로그인 유저가 일반 페이지에 있는 경우
    if (
      !isAuthed &&
      location.pathname !== PATHS['auth.login'] &&
      location.pathname !== PATHS['auth.okta-login'] &&
      location.pathname !== PATHS['auth.okta-signup'] &&
      location.pathname !== PATHS['auth.okta-signup-complete'] &&
      location.pathname !== PATHS['auth.okta-access-denied'] &&
      location.pathname !== PATHS['auth.deactivated']
    ) {
      navigate(PATHS['auth.login'], { replace: true })
      return
    }

    /***** 로그인 *****/
    // 로그인 했고 메인페이지인 경우
    if (!isOnAuth) {
      // 토큰이 유효한지 체크
      checkUser.mutateAsync().catch((e) => {
        // LOGISPRD-9057: Okta 멤버십 403(미등록/미승인/정지)은 응답 인터셉터(request.ts)가 안내+로그아웃을
        // 단일 처리한다. 여기서 또 native alert/logout 을 치면 중복(메시지 2개 + logout 2회)이 되므로 건너뛴다.
        if (AUTH_MEMBERSHIP_ERROR_CODES.has(Utils.getApiErrorCode(e) ?? '')) return
        alert('토큰이 유효하지 않습니다.')
        AuthUtils.logout()
      })
    }

    onCheckAuthFlow()
  }, [])

  return <></>
}

export default AuthChecker
